import { render, staticRenderFns } from "./ymXiangQing.vue?vue&type=template&id=2e143c21&scoped=true"
import script from "./ymXiangQing.vue?vue&type=script&lang=js"
export * from "./ymXiangQing.vue?vue&type=script&lang=js"
import style0 from "./ymXiangQing.vue?vue&type=style&index=0&id=2e143c21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e143c21",
  null
  
)

export default component.exports